import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useIsExpandedContext } from "components/BudgetBuilder/Overview/OverviewLineItemsList/OverviewLineItemsList";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { budgetBuilderSelectors } from "store/selectors";

import styles from "./styles.css";


export const OverviewTableHeader = () => {
	const { dateFormatter } = useTenantFormatter();
	const periodList = useSelector(budgetBuilderSelectors.periodRows);
	const { isExpandedState, isExpandedDispatch } = useIsExpandedContext();

	const isExpanded = useMemo(() => {
		for (let key in isExpandedState) {
			if (isExpandedState[key]) {
				return true;
			}
		}

		return false;
	}, [ isExpandedState ]);

	const onExpandToggle = () => isExpandedDispatch({ type: "setAllIsExpanded", isExpanded: !isExpanded });

	return (
		<Table.Header>
			<Table.Row>
				<Table.HeaderCell className={`${styles.cellAlignLeft} ${styles.expandCell}`}>
					<span>{"Line Item"}</span>
					{(isExpanded) && (
						<div className={styles.expandIcon} onClick={onExpandToggle}>
							<i className="fa fa-caret-down" aria-hidden="true" />
						</div>
					)}
					{(!isExpanded) && (
						<div className={styles.expandIcon} onClick={onExpandToggle}>
							<i className="fa fa-caret-right" aria-hidden="true" />
						</div>
					)}
				</Table.HeaderCell>
				{periodList?.map((period, i) => (
					<Table.HeaderCell className={styles.cellAlignCenter} key={`period-${i}`}>
						{`${dateFormatter(period.startDate)} - ${dateFormatter(period.endDate)}`}
					</Table.HeaderCell>
				))}
				<Table.HeaderCell className={styles.cellAlignRight}>
					{"Line Item Total"}
				</Table.HeaderCell>
			</Table.Row>
		</Table.Header>
	);
};

